

import Stepper from 'primevue/stepper';
import StepList from 'primevue/steplist';
import StepPanels from 'primevue/steppanels';
import StepItem from 'primevue/stepitem';
import Step from 'primevue/step';
import StepPanel from 'primevue/steppanel';

import Card from 'primevue/card';
import ProgressSpinner from 'primevue/progressspinner';

import { computed, defineComponent, onMounted, ref, watch } from 'vue';
import { useAuthStore } from '../../stores/auth';
import { storeToRefs } from 'pinia';
import { depositWithdraw } from '../../apis/deposit_withdraw';
import {BankDepositResult} from '../../types/deposit_withdraw';
import { useWebStore } from '../../stores/web';
import BankDetail from '../card/BankDetail.vue';
import Button from 'primevue/button';
import { useToast } from 'primevue/usetoast';
import { showVuePopup } from '../../utils/showVuePopup';
import WalletUpdate from '../../popup/WalletUpdate.vue';
import { useSession } from '../../stores/session';

export default defineComponent({
	name: 'DepositAuto',
	components: {
		BankDetail,
		Button,
		Stepper,
		StepList,
		StepPanels,
		StepItem,
		Step,
		StepPanel,
		Card,
		ProgressSpinner,
	},
	setup() {
		const auth = useAuthStore();
		const {profile} = storeToRefs(auth);
		auth.hydrate();

		const web = useWebStore();
		web.hydrate();
		const { webPermission } = storeToRefs(web)

		const toast = useToast();
		const session = useSession();

		onMounted( () => {
			auth.hydrate();
			web.hydrate();
			handleDeposit();
		})

		const stepper = ref<string>('1');
		watch(stepper, (stepper: string) => {
			console.log(stepper);
		})

		const isActive = ref<boolean>(webPermission.value?.isDeposit.isAuto || false);

		const isBankUpdate = computed(() => !(!!profile.value?.customerBankAccount && !!profile.value?.customerBankName))

		const bankAccount = ref({
			data: {
				fullName: (profile.value?.firstName ?? '') + ' ' + (profile.value?.lastName ?? ''),
				bankName: profile.value?.customerBankName ?? '',
				bankNumber: profile.value?.customerBankAccount ?? '',
				bankCode: profile.value?.customerBankName ?? '',
			},
			active: true,
			loading: false,
		})

		const bankDeposit = ref({
			data: {
				fullName: '',
				bankName: '',
				bankNumber: '',
				bankCode: '',
			},
			active: false,
			loading: false,
		});

		const handleDeposit = async () => {
			bankDeposit.value.loading = true;
			try {
				const resp = await depositWithdraw.getBankDeposit({ accountType: 'AUTO', limit: 1 });

				if (resp.code === '8017') {
					alert(resp.message);
					await auth.logout();
					window.location.reload();
					return;
				}

				if (resp.code !== '0') throw new Error(resp.message);

				if (!Array.isArray(resp.result) || (resp?.result || []).length < 1) {
					bankDeposit.value.active = false;
					throw new Error('ไม่พบบัญชีธนาคาร กรุณาติดต่อ Support');
				}

				const result = resp.result as BankDepositResult[];

				const data = result[0];

				bankDeposit.value.data = {
					fullName:  data.accountName,
					bankName: data.bankName,
					bankNumber: data.accountNumber,
					bankCode: data.accountBankName,
				}

				bankDeposit.value.active = true;
			} catch (error: any) {

				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				bankDeposit.value.loading = false;
			}
		};

		const btnClickUpdateBank = async () => {
			session.set('navbar_primary', 'wallet');
			session.set('navbar_sub', 'wallet:update');
			await showVuePopup(WalletUpdate, {tabs: 'bank'})
		}



		return {
			profile,
			stepper,
			bankAccount,
			bankDeposit,
			isActive,
			isBankUpdate,
			btnClickUpdateBank,
		}
	},
})
